<template>
    <b-navbar toggleable="sm" type="white" variant="white" class="border-bottom">
        <!-- <b-button variant="ligth">
            <font-awesome-icon icon="bars"></font-awesome-icon>
        </b-button> -->

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>

            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <!-- <div class="d-flex">
                <font-awesome-icon icon="bell" style="margin-top:12px;"></font-awesome-icon>
                <span class="dot counter counter-lg">999</span>&nbsp;&nbsp;
              </div> -->

                <!-- <b-nav-item-dropdown right class="mr-3">
                  <template v-slot:button-content>
                    <font-awesome-icon icon="bell"></font-awesome-icon>
                    <span class="badge badge-danger badge-pill counter">99</span>
                  </template>
                  <b-dropdown-item href="#">List 1</b-dropdown-item>
                  <b-dropdown-item href="#">List 2</b-dropdown-item>
                </b-nav-item-dropdown> -->

                <b-nav-item-dropdown right class="text-dark">
                    <!-- Using 'button-content' slot -->
                    <template v-slot:button-content>
                        {{$store.getters['account/accountData'].firstName}} {{$store.getters['account/accountData'].lastName}}
                    </template>
                    <div class="hovered">
                      <b-dropdown-item href="#/profile" class="icon-profile ml-4"> Profile</b-dropdown-item>
                    </div>
                    <hr>
                    <b-dropdown-item class="text-center" href="#/logout"><b-button pill variant="danger" style="text-transform:uppercase!important; font-weight:bold!important; margin-top:-10px!important; font-size:13px!important;"><font-awesome-icon icon="sign-out-alt"></font-awesome-icon> Log Out</b-button></b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>
        </b-collapse>
    </b-navbar>
</template>
<script>
export default {
    methods: {
    }
}
</script>